import { getAllPageNextJs, getPageNextJsByUrl } from 'cache-service/pageNextJs';
import AnalysisPage, {
  getStaticProps as analysisGetStaticProps,
} from 'page-templates/AnalysisPage';
import Category, { getStaticProps as categoryGetStaticProps } from 'page-templates/Category';
import PostDetail, { getStaticProps as postDetailGetStaticProps } from 'page-templates/PostDetail';
import TopicGroup, { getStaticProps as topicGroupGetStaticProps } from 'page-templates/TopicGroup';
// import WpPage, { getStaticProps as wpPageGetStaticProps } from 'page-templates/WpPage';
import React from 'react';

export const getStaticPaths = async () => {
  const pageNextJsAll = await getAllPageNextJs();

  const paths = pageNextJsAll.data.content.map((page) => {
    const { url } = page;
    return {
      params: { rootUrl: url.split('/') },
    };
  });

  return {
    paths: paths,
    fallback: false,
  };
};

export const getStaticProps = async (context) => {
  const { params } = context;
  const { rootUrl } = params;
  try {
    const res = await getPageNextJsByUrl(rootUrl.join('/'));
    const pageNextJs = res.data.content;
    let props = { props: { pageNextJs } };
    // const logTime =
    //   "Create getStaticProps: " +
    //   (pageNextJs ? pageNextJs.url : "IN_VALID_URL");
    // console.time(logTime);
    if (!pageNextJs) {
      return { props: {} };
    }
    switch (pageNextJs?.type) {
      case 'POST_DETAIL':
        props = await postDetailGetStaticProps({ pageNextJs });
        break;
      case 'TOPIC_GROUP':
        props = await topicGroupGetStaticProps({ pageNextJs });
        break;
      case 'PAGE_CATEGORY':
        props = await categoryGetStaticProps({ pageNextJs });
        break;
      case 'PAGE_PRODUCT_ANALYSIS':
        props = await analysisGetStaticProps({ pageNextJs });
        break;
      default:
        break;
    }
    // console.timeEnd(logTime);
    return { props: { pageNextJs, ...props.props } };
  } catch (e) {
    console.error(e);
  }

  return { props: {} };
};

const RootPage = (props) => {
  const pageType = props.pageNextJs ? props.pageNextJs.type : 'IN_VALID';
  const renderPage = () => {
    switch (pageType) {
      case 'POST_DETAIL':
        return <PostDetail {...props} />;
      case 'TOPIC_GROUP':
        return <TopicGroup {...props} />;
      // case 'LANDING_PAGE_IFRAME':
      //   return <LandingPage {...props} />;
      case 'PAGE_CATEGORY':
        return <Category {...props} />;
      case 'PAGE_PRODUCT_ANALYSIS':
        return <AnalysisPage {...props} />;
      case 'IN_VALID':
        return <div>PAGE TYPE IN_VALID</div>;
      default:
        return <div>Chưa hoàn thành UI {pageType}</div>;
    }
  };
  return <>{renderPage()}</>;
};

export default RootPage;
